<template>
  <div id="inside">
    <div v-bind:class="largura > 500 ? 'container' : ''">
      <nav class="navbar3 navbar-light navbar-expand" v-if="!loading">
        <div class="container justify-content-center pt-0">
          <button
            class="navbar-toggler navbar-toggler-right border-0"
            type="button"
            data-toggle="collapse"
            data-target="#navbar3"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div
            class="collapse navbar-collapse text-center justify-content-center"
            id="navbar3"
          >
            <ul class="navbar-nav justify-content-between">
              <li
                v-bind:class="[
                  this.currentPage !== 'meusAcordos'
                    ? 'nav-item border-bottom border-info mx-5 mb-2'
                    : 'nav-item mx-5',
                ]"
              >
                <a class="nav-link active" @click="home" style="cursor: pointer"
                  >Propostas</a
                >
              </li>
              <li
                v-bind:class="[
                  this.currentPage === 'meusAcordos'
                    ? 'nav-item border-bottom border-info mx-5 mb-2'
                    : 'nav-item mx-5',
                ]"
              >
                <a class="nav-link" @click="meusAcordos" style="cursor: pointer"
                  >Acordos
                  <span
                    class="badge badge-primary badge-pill"
                    v-if="agreements.length"
                    >{{ agreements !== null ? agreements.length : 0 }}</span
                  >
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div class="col-12 col-lg-12 mt-4">
        <div class="row">
          <div class="col-lg-12">
            <h5 class="mb-0" style="color: #3a4148; font-weight: 600">
              Meus Acordos
            </h5>
            <p
              class="mb-0"
              style="color: #3a4148; font-weight: 400; font-style: italic"
              v-if="agreements.length > 0 && !loading"
            >
              Veja seu histórico de negociações
            </p>
            <p
              v-if="agreements.length <= 0 && !loading"
              class="mb-0 mt-4 text-center p-5"
              style="
                color: #3a4148;
                font-weight: 400;
                font-style: italic;
                background-color: #fff;
                border-radius: 10px;
              "
            >
              No momento não existe nenhum acordo em andamento.
            </p>
          </div>
        </div>
      </div>
      <div class="container" v-if="!loading">
        <div v-bind:class="largura > 500 ? 'row' : ''">
          <div
            v-for="(agreement, key, index) in agreements"
            :key="`${key}-${index}`"
            style="max-width: 404px"
          >
            <div
              class="col-lg-4 col-md-6 col-12"
              style="padding: 10px"
              v-if="
                Array.isArray(agreement.parcelas) &&
                agreement.parcelas.length <= 1
              "
            >
              <div class="card mb-0 mt-0">
                <div
                  class="card-body"
                  v-if="!isCardInfoOpen(agreement.contrato)"
                >
                  <h6
                    v-if="isUnicaCredor(agreement)"
                    class="mb-3"
                    style="font-weight: 600; color: #3a4148"
                  >
                    Mensalidade POS Única
                  </h6>
                  <div
                    v-for="(item, key1, index1) in agreement.parcelas"
                    :key="`${key1}-${index1}`"
                  >
                    <div class="resumo-line">
                      <p>Acordo Nº</p>
                      <p>{{ agreement.contrato }}</p>
                    </div>
                    <!-- <div class="resumo-line">
                    <p>Contrato(s)</p>
                    <p>{{ agreement.contrato }}</p>
                  </div> -->
                    <!-- <div class="resumo-line">
                    <p>Data do Acordo</p>
                    <p>
                      {{
                      formatData(
                        agreement.parcelas[0].vencimento,
                        "YYYY-MM-DD",
                        "DD/MM/YYYY"
                      )
                    }}
                    </p>
                  </div> -->
                    <div class="resumo-line">
                      <p>Situação Acordo</p>
                      <p class="status-pg">• Aguardando pagamento</p>
                    </div>
                    <div class="resumo-line">
                      <p>Plano de pagamento</p>
                      <p>À vista</p>
                    </div>
                    <div class="resumo-line">
                      <p>Valor a pagar</p>
                      <p style="font-weight: bold; font-size: 13pt">
                        {{ formatCurrency(item.valor) }}
                      </p>
                    </div>
                    <div class="resumo-line">
                      <p>Vencimento</p>
                      <p>
                        {{
                          formatData(
                            item.vencimento,
                            "YYYY-MM-DD",
                            "DD/MM/YYYY"
                          )
                        }}
                      </p>
                    </div>
                    <div class="resumo-line">
                      <p>Boleto</p>
                      <div
                        class="d-flex"
                        style="
                          background-color: #eff0f2;
                          border-radius: 4px;
                          padding-right: 8px;
                          padding-left: 8px;
                          gap: 4px;
                          cursor: pointer;
                        "
                        @click="getInfoInstallment(agreement, item)"
                      >
                        <p>Baixar</p>
                        <img
                          src="/img/download.svg"
                          class="ml-2"
                          style="width: 15px"
                        />
                      </div>
                    </div>
                    <ProgressLoading
                      :loading="!!loadingByAgreement[agreement.contrato]"
                    />
                  </div>
                </div>

                <div
                  class="card-body"
                  v-if="
                    isCardInfoOpen(agreement.contrato) &&
                    getInfoBill(agreement.contrato)
                  "
                >
                  <div
                    v-for="(value, key2, index2) in getInfoBill(
                      agreement.contrato
                    ).DADOBOLETO"
                    :key="`${key2}-${index2}`"
                  >
                    <div class="card-header p-0">
                      <div
                        class="d-flex"
                        @click="voltar(agreement.contrato)"
                        style="cursor: pointer"
                      >
                        <i class="fa fa-chevron-left fa-fw grey01"></i>
                        <h6
                          class="ml-1"
                          style="font-weight: bold; color: black"
                        >
                          Voltar para lista de acordos
                        </h6>
                      </div>
                      <hr />
                    </div>
                    <h6
                      v-if="isUnicaCredor(agreement)"
                      class="mb-3"
                      style="font-weight: 600; color: #3a4148"
                    >
                      Mensalidade POS Única
                    </h6>
                    <h6 v-if="agreement.parcelas && agreement.parcelas.length > 1">Parcela(s) selecionada(s)</h6>
                    <div class="resumo-line">
                      <p>Acordo Nº</p>
                      <p>{{ agreement.contrato }}</p>
                    </div>
                    <div class="resumo-line" v-if="hasEntrada(agreement)">
                      <p>Entrada</p>
                      <p style="font-weight: bold; font-size: 13pt">
                        {{ formatCurrency(agreement.parcelas[0].valor) }}
                      </p>
                    </div>
                    <div class="resumo-line">
                      <p>Vencimento do boleto</p>
                      <p>
                        {{
                          formatData(value.DATVENCI, "YYYY-MM-DD", "DD/MM/YYYY")
                        }}
                      </p>
                    </div>
                    <div class="resumo-line">
                      <p>Valor total a pagar</p>
                      <p style="font-weight: bold; font-size: 13pt">
                        {{ formatCurrency(value.VALPAGO) }}
                      </p>
                    </div>
                    <hr />

                    <div
                      class="d-inline-flex flex-wrap col-lg-12 flex-column mt-1 p-0"
                    >
                      <!-- <div class=""> -->
                      <p class="text-info mb-1">Linha digitável:</p>
                      <!-- <a
                  class="btn btn-link float-right mr-1"
                  style="cursor: pointer"
                  ><i class="fa fa-clone text-body"></i>
                </a> -->
                      <p
                        class="codebar"
                        style="cursor: pointer"
                        @click="copiarLinhaDigitável(value.LINHADIGITAVEL, agreement)"
                      >
                        {{ value.LINHADIGITAVEL }}
                      </p>
                      <p
                        class="text-info float-left mb-1"
                        style="
                          font-size: 12px;
                          cursor: pointer;
                          text-decoration: underline;
                          color: #1b669b !important;
                        "
                        onmouseover="this.style.textDecoration='underline'"
                        onmouseout="this.style.textDecoration='none'"
                        @click="copiarLinhaDigitável(value.LINHADIGITAVEL, agreement)"
                      >
                        Clique para copiar
                      </p>
                      <button
                        class="btn btn-pill2 btn-block text-left my-4"
                        :disabled="!!loadingByAgreement[agreement.contrato]"
                        @click="generatePDF(value, agreement)"
                      >
                        <i class="fa fa-arrow-right float-right mt-2"></i>
                        <img src="/img/download.svg" class="pr-4 pl-1" /> Baixar
                        boleto
                      </button>
                      <h6>Ou receba por outros canais</h6>
                      <!-- <button
                        class="btn btn-pill2 btn-block text-left my16"
                        :disabled="true"
                      >
                        <i class="fa fa-arrow-right float-right mt-2"></i>
                        <img
                          src="/img/whatsapp.svg"
                          class="pr-4 pl-1"
                          :disabled="true"
                        />
                        Receber por WhatsApp</button
                      > -->
                      <button
                        class="btn btn-pill2 btn-block text-left my16 mb-3"
                        :disabled="loadingDownloadBoleto || loading"
                        @click="openModalInformarContatos('sms', agreement)"
                        style="cursor: pointer"
                      >
                        <i class="fa fa-arrow-right float-right mt-2"></i>
                        <img src="/img/sms.svg" class="pr-4 pl-1" /> Receber por
                        SMS
                      </button>
                      <button
                        class="btn btn-pill2 btn-block text-left mb-3"
                        :disabled="loadingDownloadBoleto || loading"
                        @click="openModalInformarContatos('email', agreement)"
                        style="cursor: pointer"
                      >
                        <i class="fa fa-arrow-right float-right mt-2"></i>
                        <img
                          src="/img/arroba.svg"
                          class="pr-4 pl-1"
                        />&nbsp;Receber por E-MAIL
                      </button>
                      <!-- </div> -->

                      <button
                        class="btn btn-primary btn-block text-white mt-4"
                        @click="voltar(agreement.contrato)"
                      >
                        CONCLUIR
                      </button>

                      <div
                        class="card"
                        v-if="!!loadingByAgreement[agreement.contrato]"
                      >
                        <ProgressLoading
                          :loading="!!loadingByAgreement[agreement.contrato]"
                        />
                      </div>
                    </div>
                    <!-- <ProgressLoading v-bind:loading="loadInstallment" /> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- PARCELADO -->
            <div
              class="col-lg-4 col-md-6 col-12"
              v-if="
                Array.isArray(agreement.parcelas) &&
                agreement.parcelas.length > 1
              "
            >
              <div class="card">
                <div
                  class="card-body"
                  v-if="!isCardInfoOpen(agreement.contrato)"
                >
                  <h6
                    v-if="isUnicaCredor(agreement)"
                    class="mb-3"
                    style="font-weight: 600; color: #3a4148"
                  >
                    Mensalidade POS Única
                  </h6>
                  <!-- <div class="resumo-line">
                    <p>Acordo Nº</p>
                    <p>XXXX</p>
                  </div> -->
                  <div class="resumo-line">
                    <p>Contrato(s)</p>
                    <p>{{ agreement.contrato }}</p>
                  </div>
                  <!-- <div class="resumo-line">
                    <p>Data do Acordo</p>
                    <p>
                      XXXX
                    </p>
                  </div> -->
                  <div class="resumo-line">
                    <p>Situação Acordo</p>
                    <p class="status-pg">• Aguardando pagamento</p>
                  </div>
                  <div class="resumo-line" v-if="agreement.parcelas.length > 0">
                    <p>Plano de pagamento</p>
                    <p>Parcelado</p>
                  </div>
                  <div class="resumo-line" v-else>
                    <p>Plano de pagamento</p>
                    <p>À vista</p>
                  </div>
                  <div class="resumo-line" v-if="hasEntrada(agreement)">
                    <p>Entrada</p>
                    <p style="font-weight: bold; font-size: 13pt">
                      {{ formatCurrency(agreement.parcelas[0].valor) }}
                    </p>
                  </div>
                  <div class="resumo-line" v-if="hasEntrada(agreement)">
                    <p>Vencimento da entrada</p>
                    <p>
                      {{
                        formatData(
                          agreement.parcelas[0].vencimento,
                          "YYYY-MM-DD",
                          "DD/MM/YYYY"
                        )
                      }}
                    </p>
                  </div>
                  <div class="resumo-line" v-else>
                    <p>Vencimento</p>
                    <p>XXXX</p>
                  </div>
                  <hr />

                  <p
                    style="cursor: pointer"
                    @click="toggleBills(agreement.contrato)"
                  >
                    Ver boletos das parcelas
                    <i
                      class="fa fa-chevron-down"
                      v-if="!isBillsOpen(agreement.contrato)"
                    ></i>
                    <i class="fa fa-chevron-up" v-else></i>
                  </p>

                  <div
                    class="lines-deals-installments mt-3"
                    v-if="isBillsOpen(agreement.contrato)"
                  >
                    <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Parcela</th>
                            <th>Vencimento</th>
                            <th>Valor</th>
                            <th>Boleto</th>
                          </tr>
                        </thead>
                        <tbody style="font-size: 11px !important">
                          <tr v-for="(parc, k) in agreement.parcelas" :key="k">
                            <td>{{ k + 1 }}/{{ agreement.parcelas.length }}</td>
                            <td>
                              {{
                                formatData(
                                  parc.vencimento,
                                  "YYYY-MM-DD",
                                  "DD/MM/YYYY"
                                )
                              }}
                            </td>
                            <td>{{ formatCurrency(parc.valor) }}</td>
                            <td class="text-center">
                              <!-- ícone de download: reaproveita o mesmo método -->
                              <button
                                class="btn btn-link p-0"
                                :disabled="
                                  !!loadingByAgreement[agreement.contrato] ||
                                  !canDownloadInstallment(agreement, parc)
                                "
                                @click="getInfoInstallment(agreement, parc)"
                                aria-label="Baixar boleto"
                                title="Baixar boleto"
                              >
                                <img
                                  src="/img/download.svg"
                                  style="width: 15px"
                                />
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="d-flex mt-3">
                    <img src="/img/info-circle.svg" class="mr-2" style="" />
                    <p class="text-info" style="font-size: 12px">
                      Caso deseje antecipar parcelas do acordo, por favor, entre
                      em contato através dos telefones
                      <b
                        >0800 979 3355 ou 3003 3366 (capitais e regiões
                        metropolitanas).</b
                      >
                    </p>
                  </div>

                  <!-- loader só deste card -->
                  <ProgressLoading
                    :loading="!!loadingByAgreement[agreement.contrato]"
                  />
                </div>

                <div
                  class="card-body"
                  v-if="
                    isCardInfoOpen(agreement.contrato) &&
                    getInfoBill(agreement.contrato)
                  "
                >
                  <div
                    v-for="(value, idx) in getInfoBill(agreement.contrato)
                      .DADOBOLETO"
                    :key="idx"
                  >
                    <div
                      class="d-flex"
                      @click="voltar(agreement.contrato)"
                      style="cursor: pointer"
                    >
                      <i class="fa fa-chevron-left fa-fw grey01"></i>
                      <h6 class="ml-1" style="font-weight: bold; color: black">
                        Voltar para lista de acordos
                      </h6>
                    </div>
                    <h6
                      v-if="isUnicaCredor(agreement)"
                      class="mb-3 mt-3"
                      style="font-weight: 600; color: #3a4148"
                    >
                      Mensalidade POS Única
                    </h6>
                    <h6 v-if="agreement.parcelas && agreement.parcelas.length > 1">Parcela(s) selecionada(s)</h6>
                    <div class="resumo-line">
                      <p>Acordo Nº</p>
                      <p>{{ agreement.contrato }}</p>
                    </div>
                    <div class="resumo-line" v-if="hasEntrada(agreement)">
                      <p>Entrada</p>
                      <p style="font-weight: bold; font-size: 13pt">
                        {{ formatCurrency(agreement.parcelas[0].valor) }}
                      </p>
                    </div>
                    <div class="resumo-line">
                      <p>Vencimento do boleto</p>
                      <p>
                        {{
                          formatData(value.DATVENCI, "YYYY-MM-DD", "DD/MM/YYYY")
                        }}
                      </p>
                    </div>
                    <div class="resumo-line">
                      <p>Valor total a pagar</p>
                      <p style="font-weight: bold; font-size: 13pt">
                        {{ formatCurrency(value.VALPAGO) }}
                      </p>
                    </div>
                    <hr />

                    <div
                      class="d-inline-flex flex-wrap col-lg-12 flex-column mt-1 p-0"
                    >
                      <!-- <div class=""> -->
                      <p class="text-info mb-1">Linha digitável:</p>
                      <!-- <a
                  class="btn btn-link float-right mr-1"
                  style="cursor: pointer"
                  ><i class="fa fa-clone text-body"></i>
                </a> -->
                      <p
                        class="codebar"
                        style="cursor: pointer"
                        @click="copiarLinhaDigitável(value.LINHADIGITAVEL, agreement)"
                      >
                        {{ value.LINHADIGITAVEL }}
                      </p>
                      <p
                        class="text-info float-left mb-1"
                        style="
                          font-size: 12px;
                          cursor: pointer;
                          text-decoration: underline;
                          color: #1b669b !important;
                        "
                        onmouseover="this.style.textDecoration='underline'"
                        onmouseout="this.style.textDecoration='none'"
                        @click="copiarLinhaDigitável(value.LINHADIGITAVEL, agreement)"
                      >
                        Clique para copiar
                      </p>
                      <button
                        class="btn btn-pill2 btn-block text-left my-4"
                        :disabled="!!loadingByAgreement[agreement.contrato]"
                        @click="generatePDF(value, agreement)"
                      >
                        <i class="fa fa-arrow-right float-right mt-2"></i>
                        <img src="/img/download.svg" class="pr-4 pl-1" /> Baixar
                        boleto
                      </button>
                      <h6>Ou receba por outros canais</h6>
                      <!-- <button
                        class="btn btn-pill2 btn-block text-left my16"
                        :disabled="true"
                      >
                        <i class="fa fa-arrow-right float-right mt-2"></i>
                        <img
                          src="/img/whatsapp.svg"
                          class="pr-4 pl-1"
                          :disabled="true"
                        />
                        Receber por WhatsApp</button
                      > -->
                      <button
                        class="btn btn-pill2 btn-block text-left my16 mb-3"
                        :disabled="loadingDownloadBoleto || loading"
                        @click="openModalInformarContatos('sms', agreement)"
                        style="cursor: pointer"
                      >
                        <i class="fa fa-arrow-right float-right mt-2"></i>
                        <img src="/img/sms.svg" class="pr-4 pl-1" /> Receber por
                        SMS
                      </button>
                      <button
                        class="btn btn-pill2 btn-block text-left mb-3"
                        :disabled="loadingDownloadBoleto || loading"
                        @click="openModalInformarContatos('email', agreement)"
                        style="cursor: pointer"
                      >
                        <i class="fa fa-arrow-right float-right mt-2"></i>
                        <img
                          src="/img/arroba.svg"
                          class="pr-4 pl-1"
                        />&nbsp;Receber por E-MAIL
                      </button>
                      <!-- </div> -->

                      <button
                        class="btn btn-primary btn-block text-white mt-4"
                        @click="voltar(agreement.contrato)"
                      >
                        CONCLUIR
                      </button>

                      <div
                        class="card"
                        v-if="!!loadingByAgreement[agreement.contrato]"
                      >
                        <ProgressLoading
                          :loading="!!loadingByAgreement[agreement.contrato]"
                        />
                      </div>
                    </div>
                    <!-- <ProgressLoading v-bind:loading="loadInstallment" /> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAIS -->
    <div
      class="modal fade"
      id="informarContatos"
      style="background-color: #000000a3"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" style="font-weight: bold">
              Informe seus contatos
            </h5>
            <button type="button" @click="closeModalInformarContatos()">
              <span style="font-size: 12pt">×</span>
            </button>
          </div>
          <div class="modal-body pt-0">
            <form class="mb-0">
              <div class="form-group my-0">
                <div class="form-group mb-1">
                  <label>Informe o número de telefone</label>
                  <the-mask
                    type="tel"
                    class="form-control form-control-sm"
                    placeholder="(00) 00000-0000"
                    v-model="phoneNumber"
                    mask="(##) # ####-####"
                  ></the-mask>
                </div>
                <div class="form-group mt-2">
                  <label>Informe seu e-mail</label>
                  <input
                    type="email"
                    class="form-control form-control-sm"
                    style="border-radius: 4px"
                    placeholder="exemplo@exemplo.com"
                    v-model="email"
                  />
                </div>
              </div>
            </form>
            <!-- :disabled="
                isAboveThan ||
                isBelowThan ||
                loading ||
                !convertCurrencyToFloat(entryValue) > 0
              " -->
            <button
              class="btn btn-primary btn-block mt-4"
              @click="sentBill()"
              :disabled="loadingSentBill"
            >
              RECEBER BOLETO
            </button>
            <button
              class="btn btn-link btn-block"
              :disabled="loadingSentBill"
              @click="closeModalInformarContatos()"
            >
              CANCELAR
            </button>
            <ProgressLoading v-bind:loading="loadingSentBill" />
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="boletoEnviado"
      style="background-color: #000000a3"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" style="font-weight: bold">
              Boleto enviado!
            </h5>
            <button type="button" @click="closeModalConfirmSentBill()">
              <span style="font-size: 12pt">×</span>
            </button>
          </div>
          <div class="modal-body pt-0">
            <div class="form-group my-0">
              <div class="form-group mb-1">
                <div class="">
                  <p class="" style="">
                    Seu boleto foi enviado através do canal escolhido.
                  </p>
                </div>
              </div>
            </div>
            <!-- :disabled="
                isAboveThan ||
                isBelowThan ||
                loading ||
                !convertCurrencyToFloat(entryValue) > 0
              " -->
            <button
              class="btn btn-primary btn-block mt-4"
              @click="closeModalConfirmSentBill()"
            >
              OBRIGADO
            </button>
            <ProgressLoading v-bind:loading="loading" />
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="boletoBaixado"
      style="background-color: #000000a3"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" style="font-weight: bold">
              Boleto baixado!
            </h5>
            <button type="button" @click="closeModalConfirmDownloadBill()">
              <span style="font-size: 12pt">×</span>
            </button>
          </div>
          <div class="modal-body pt-0">
            <div class="form-group my-0">
              <div class="form-group mb-1">
                <div class="">
                  <p class="" style="">
                    Seu boleto foi baixado. Se precisar de uma segunda via,
                    acesse a guia acordos.
                  </p>
                </div>
              </div>
            </div>
            <!-- :disabled="
                isAboveThan ||
                isBelowThan ||
                loading ||
                !convertCurrencyToFloat(entryValue) > 0
              " -->
            <button
              class="btn btn-primary btn-block mt-4"
              @click="closeModalConfirmDownloadBill()"
            >
              OBRIGADO
            </button>
            <ProgressLoading v-bind:loading="loading" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { TheMask } from "vue-the-mask";
import ProgressLoading from "../../../modules/auth/components/ProgressLoading.vue";
import {
  formatFloatToReal,
  formatData,
  isValidPhoneNumber,
} from "@/utils/helpers";

export default {
  name: "MeusAcordos",
  components: {
    ProgressLoading,
    TheMask,
  },
  directives: {
    // TheMask,
  },
  data() {
    return {
      links: [],
      currentPage: "meusAcordos",
      openBillsInstallments: true,
      loading: false,
      largura: null,
      loadingDownloadBoleto: false,
      agreements: null,
      showInfoInstallment: false,
      showInfoInstallmentInCash: false,
      loadInstallment: false,
      infoBill: null,
      phoneNumber: null,
      email: null,
      from: null,
      contactCredor: null,
      loadingSentBill: false,
      valorParcela: null,
      openInfoByAgreement: {}, // { [contrato]: boolean }
      infoBillByAgreement: {}, // { [contrato]: objeto do boleto }
      loadingByAgreement: {},
      openBillsByAgreement: {},
    };
  },
  methods: {
    formatFloatToReal,
    formatData,
    isValidPhoneNumber,

    parseCurrencyToNumber(value) {
      if (value === null || value === undefined || value === "") return 0;
      if (typeof value === "number") return value;

      const raw = String(value).trim();
      const onlyNumbers = raw.replace(/[^\d,.-]/g, "");

      const hasComma = onlyNumbers.includes(",");
      const hasDot = onlyNumbers.includes(".");

      if (hasComma && hasDot) {
        // pt-BR: 1.234.567,89 -> 1234567.89
        return Number(onlyNumbers.replace(/\./g, "").replace(",", "."));
      }

      if (hasComma) {
        // pt-BR sem milhar: 1019,65 -> 1019.65
        return Number(onlyNumbers.replace(",", "."));
      }

      return Number(onlyNumbers);
    },

    formatCurrency(value) {
      const numValue = this.parseCurrencyToNumber(value);
      return formatFloatToReal(Number.isNaN(numValue) ? 0 : numValue);
    },

    ...mapActions("minhasDividas", [
      "ActionDownloadBoleto",
      "ActionSendEmailOrSmsText",
      "ActionGetInvoicesTribanco",
      "ActionViewAgreementsTribanco",
      "ActionLogDownloadBoleto",
      "ActionLogCopyDigitableLine",
    ]),

    meusAcordos() {
      return;
    },

    home() {
      localStorage.setItem("currentPage", "dashboard");
      this.$router.push({ name: "dashboard", params: { from: 'meusAcordos' } });
    },

    async sentBill() {
      this.loadingSentBill = true;
      try {
        // pega o único item dentro de infoBillByAgreement
        const item = Object.values(this.infoBillByAgreement || {})[0];
        if (!item) throw new Error("Dados do boleto indisponíveis.");

        // API pode mandar DADODOBOLETO ou DADOBOLETO
        const arr = item.DADODOBOLETO || item.DADOBOLETO || [];
        const linha = arr[0]?.LINHADIGITAVEL;
        if (!linha) throw new Error("Linha digitável não encontrada.");

        if (this.from === "sms") {
          await this.sendSms(linha);
        } else if (this.from === "email") {
          await this.sendEmail(linha);
        } else {
          throw new Error("Selecione SMS ou e-mail.");
        }

        this.closeModalInformarContatos();
        this.openModalConfirmSentBill();
      } catch (e) {
        this.showError?.(e.message || "Falha ao enviar boleto.");
      } finally {
        this.from = null;
        this.loadingSentBill = false;
      }
    },

    openCloseBillsInstallments() {
      this.openBillsInstallments = !this.openBillsInstallments;
    },

    openModalInformarContatos(from, agreement) {
      this.from = from;
      this.contactCredor = agreement && agreement.credor;
      // this.validateProposalOptions();
      const modal = document.getElementById("informarContatos");
      modal.classList.add("show");
      modal.style.display = "block";
      document.body.classList.add("modal-open");
    },

    closeModalInformarContatos() {
      document.getElementById("informarContatos").style.display = "none";
    },

    openModalConfirmSentBill() {
      // this.validateProposalOptions();
      const modal = document.getElementById("boletoEnviado");
      modal.classList.add("show");
      modal.style.display = "block";
      document.body.classList.add("modal-open");
    },

    closeModalConfirmSentBill() {
      document.getElementById("boletoEnviado").style.display = "none";
    },

    openModalConfirmDownloadBill() {
      // this.validateProposalOptions();
      const modal = document.getElementById("boletoBaixado");
      modal.classList.add("show");
      modal.style.display = "block";
      document.body.classList.add("modal-open");
    },

    closeModalConfirmDownloadBill() {
      document.getElementById("boletoBaixado").style.display = "none";
    },

    generatePDF(value, agreement) {
      // Se for invoice, usar DownloadLink diretamente
      if (value.DownloadLink) {
        const downloadLink = document.createElement("a");
        downloadLink.setAttribute("target", "_blank");
        downloadLink.href = value.DownloadLink;
        downloadLink.click();
        this.logDownloadBoleto({
          digitableLine: value.LINHADIGITAVEL || value.DigitableLine,
          credor: agreement && agreement.credor,
        });
        this.openModalConfirmDownloadBill();
        return;
      }

      // Caso contrário, usar BASE64 como antes
      const linkSource = `data:application/pdf;base64,${value.BASE64 || value}`;
      const downloadLink = document.createElement("a");
      downloadLink.setAttribute("target", "_blank");
      const fileName = "boleto-parcela.pdf";
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.logDownloadBoleto({
        digitableLine: value.LINHADIGITAVEL || value.DigitableLine,
        contrato: value.CONTRATOS || value.DESCONTR,
        credor: agreement && agreement.credor,
      });
      this.openModalConfirmDownloadBill();
    },

    logDownloadBoleto(extra = {}) {
      this.ActionLogDownloadBoleto({
        IP: this.ipUser || "",
        OS: typeof navigator !== "undefined" ? navigator.platform : "",
        UserID: this.userAdm ? this.userAdm.UserID : null,
        UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
        digitableLine: extra.digitableLine,
        contrato: extra.contrato,
        credor: extra.credor,
        NotesJson: {
          action: "download_boleto",
          digitableLine: extra.digitableLine || undefined,
          contrato: extra.contrato || undefined,
          credor: extra.credor || undefined,
          downloadedAt: new Date().toISOString(),
        },
      });
    },

    isUnicaCredor(agreement) {
      return String(agreement?.credor || "").toUpperCase() === "UNICA";
    },

    hasEntrada(agreement) {
      const parcelas = agreement && agreement.parcelas;
      if (!Array.isArray(parcelas) || !parcelas.length || agreement.invoiceData) {
        return false;
      }
      if (this.isUnicaCredor(agreement)) return parcelas.length > 1;
      return true;
    },

    isCardInfoOpen(contrato) {
      if (contrato == null) return false;
      return !!this.openInfoByAgreement[contrato];
    },

    getInfoBill(contrato) {
      return this.infoBillByAgreement[contrato] || null;
    },

    isBillsOpen(contrato) {
      return !!this.openBillsByAgreement[contrato];
    },

    toggleBills(contrato) {
      this.$set(
        this.openBillsByAgreement,
        contrato,
        !this.isBillsOpen(contrato)
      );
    },

    async getInfoInstallment(agreement, installment) {
      const contrato = agreement?.contrato;
      if (!contrato) return;

      // loading por contrato
      this.$set(this.loadingByAgreement, contrato, true);
      this.valorParcela = installment?.valor;

      try {
        // Verificar se é um invoice (tem invoiceData)
        if (agreement.invoiceData) {
          // Para invoices, criar estrutura compatível diretamente
          const invoiceBill = {
            DADOBOLETO: [
              {
                LINHADIGITAVEL: agreement.invoiceData.DigitableLine,
                DATVENCI: installment.vencimento,
                VALPAGO: installment.valor,
                BASE64: null, // Para invoices, usaremos DownloadLink diretamente
                DownloadLink: agreement.invoiceData.DownloadLink,
              },
            ],
          };

          // guarda o boleto deste contrato e abre o card
          this.$set(this.infoBillByAgreement, contrato, invoiceBill);
          this.$set(this.openInfoByAgreement, contrato, true);
          this.$set(this.loadingByAgreement, contrato, false);
          return;
        }

        // dueDate: hoje por padrão; se a parcela vence no futuro, usa o vencimento dela
        let dueDate = new Date().toISOString().split("T")[0];
        if (installment?.vencimento && installment.vencimento >= dueDate) {
          dueDate = installment.vencimento;
        }

        const { credor, company, produto } = agreement;

        // regra credor == 1 => +5 dias
        if (credor == 1) {
          const d = new Date();
          d.setDate(d.getDate() + 5);
          dueDate = d.toISOString().split("T")[0];
        }

        const jsonToBill = {
          document: agreement.regis,
          credor,
          company,
          installments: [
            {
              product: produto || "PARC",
              contract: contrato,
              dueInstallmentDate: installment?.vencimento,
            },
          ],
          dueDate,
          tag: localStorage.getItem("tag"),
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          OS: navigator.platform,
          IP: this.ipUser || "",
        };

        const resp = await this.ActionDownloadBoleto(jsonToBill);

        // guarda o boleto deste contrato e abre o card
        this.$set(this.infoBillByAgreement, contrato, resp);
        this.$set(this.openInfoByAgreement, contrato, true);
      } catch (e) {
        console.error(e);
        this.flashMessage.show({
          timeout: 1500,
          status: "error",
          title: "Ocorreu um erro",
          message: "Não foi possível obter o boleto.",
        });
        // fecha e limpa só este contrato
        this.$delete?.(this.infoBillByAgreement, contrato);
        this.$set(this.openInfoByAgreement, contrato, false);
      } finally {
        this.$set(this.loadingByAgreement, contrato, false);
      }
    },

    voltar(contrato) {
      if (!contrato) return;

      this.$set(this.openInfoByAgreement, contrato, false);

      if (this.infoBillByAgreement[contrato]) {
        this.$delete(this.infoBillByAgreement, contrato);
      }

      this.$set(this.loadingByAgreement, contrato, false);
    },

    copiarLinhaDigitável(linhaDigitavel, agreement) {
      const elem = document.createElement("textarea");
      elem.value = linhaDigitavel;
      document.body.appendChild(elem);
      elem.select();
      document.execCommand("copy");
      document.body.removeChild(elem);

      this.ActionLogCopyDigitableLine({
        IP: this.ipUser || "",
        OS: typeof navigator !== "undefined" ? navigator.platform : "",
        UserID: this.userAdm ? this.userAdm.UserID : null,
        UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
        credor: agreement && agreement.credor,
        digitableLine: linhaDigitavel,
        NotesJson: {
          action: "copy_digitable_line",
          digitableLine: linhaDigitavel || undefined,
          credor: agreement && agreement.credor,
          copiedAt: new Date().toISOString(),
        },
      });

      this.flashMessage.show({
        timeout: 1000,
        status: "success",
        title: "Sucesso",
        blockClass: "custom-block-class",
        message: "Linha digitável foi copiada para o seu clipboard",
      });
    },

    async sendSms(LinhaDigitavel) {
      this.loading = true;

      var phoneIsValid = isValidPhoneNumber(this.phoneNumber);

      if (!phoneIsValid) {
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          title: "Error",
          message: "Informe um telefone válido!",
        });
        this.loading = false;
        return;
      }

      try {
        await this.ActionSendEmailOrSmsText({
          LinhaDigitavel,
          // Email: this.email,
          Email: null,
          PhoneNumber: this.phoneNumber,
          type: "sms",
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          OS: navigator.platform,
          IP: this.ipUser ? this.ipUser : "",
          credor: this.contactCredor,
        });
        this.loading = false;

        // this.flashMessage.show({
        //   timeout: 1000,
        //   blockClass: "custom-block-class",
        //   status: "success",
        //   title: "Sucesso",
        //   message: "Linha digitável enviado por sms com sucesso",
        // });

        this.phoneNumber = null;
        this.email = null;
      } catch {
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          title: "Ocorreu um erro",
          message: "Nenhum usuário foi encontrado!",
        });
        this.loading = false;
      }
    },

    async sendEmail(LinhaDigitavel) {
      this.loadDeal = true;

      try {
        await this.ActionSendEmailOrSmsText({
          LinhaDigitavel,
          Email: this.email,
          // PhoneNumber: this.phoneNumber,
          PhoneNumber: null,
          type: "email",
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          OS: navigator.platform,
          IP: this.ipUser ? this.ipUser : "",
          credor: this.contactCredor,
        });
        this.loadDeal = false;

        // this.flashMessage.show({
        //   timeout: 1000,
        //   blockClass: "custom-block-class",
        //   status: "success",
        //   title: "Sucesso",
        //   message: "Linha digitável enviado por e-mail com sucesso",
        // });

        this.phoneNumber = null;
        this.email = null;
      } catch {
        this.loadDeal = false;
      }
    },

    expandAllBills() {
      if (this.agreements && this.agreements.length) {
        this.agreements.forEach((a) => {
          this.$set(this.openBillsByAgreement, a.contrato, true);
        });
      }
    },

    parseDate(value) {
      if (!value) return null;
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [y, m, d] = value.split("-").map(Number);
        return new Date(y, m - 1, d);
      }
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
        const [d, m, y] = value.split("/").map(Number);
        return new Date(y, m - 1, d);
      }
      return null; // formato inesperado
    },

    // true se vencida OU se pertence ao mês/ano atuais
    isOverdueOrCurrentMonth(dateStr) {
      const due = this.parseDate(dateStr);
      if (!due) return false;

      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const dueDay = new Date(due.getFullYear(), due.getMonth(), due.getDate());

      const overdue = dueDay < today; // já venceu
      const sameMonth =
        due.getFullYear() === today.getFullYear() &&
        due.getMonth() === today.getMonth(); // parcela "atual" (mês corrente)

      return overdue || sameMonth;
    },

    // Próxima parcela a pagar: primeira com vencimento >= hoje (ou a última se todas passaram).
    findNextPayableInstallment(agreement) {
      const parcelas = agreement?.parcelas || [];
      if (!parcelas.length) return null;

      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

      const upcoming = parcelas.find((p) => {
        const due = this.parseDate(p?.vencimento);
        if (!due) return false;
        const dueDay = new Date(due.getFullYear(), due.getMonth(), due.getDate());
        return dueDay >= today;
      });

      return upcoming || parcelas[parcelas.length - 1];
    },

    canDownloadInstallment(agreement, parc) {
      if (!parc) return false;
      // Vencida ou do mês corrente
      if (this.isOverdueOrCurrentMonth(parc.vencimento)) return true;

      // Também libera a próxima parcela a vencer (entrada/parcela corrente do acordo),
      // senão acordos com 1º vencimento em mês futuro ficam sem nenhum boleto baixável.
      const next = this.findNextPayableInstallment(agreement);
      if (!next) return false;

      return (
        next === parc ||
        (next.vencimento &&
          parc.vencimento &&
          String(next.vencimento) === String(parc.vencimento) &&
          String(next.valor) === String(parc.valor))
      );
    },

    async loadInvoicesAsAgreements() {
      try {
        // Buscar invoices do localStorage primeiro
        let invoicesResponse = null;
        const storedInvoices = localStorage.getItem("contractsInvoices");
        if (storedInvoices) {
          try {
            const parsed = JSON.parse(storedInvoices);
            // Se for array, pegar o primeiro item
            invoicesResponse = Array.isArray(parsed) ? parsed[0] : parsed;
          } catch (e) {
            console.warn("Erro ao parsear invoices do localStorage:", e);
          }
        }

        // Se não houver no localStorage, buscar da API
        if (!invoicesResponse) {
          try {
            invoicesResponse = await this.ActionGetInvoicesTribanco();
          } catch (e) {
            console.warn("Erro ao buscar invoices:", e);
            return;
          }
        }

        // Transformar invoices em formato de acordo
        // A API retorna { results: { ... } } ou diretamente { ... }
        let invoice = null;
        if (invoicesResponse) {
          if (invoicesResponse.results && invoicesResponse.results.Contrato) {
            // Formato: { results: { Contrato: "...", ... } }
            invoice = invoicesResponse.results;
          } else if (invoicesResponse.Contrato) {
            // Se já for o objeto invoice diretamente
            invoice = invoicesResponse;
          }
        }

        if (invoice && invoice.Contrato) {
          // Verificar se já existe um acordo com este contrato
          const existingAgreementIndex = this.agreements.findIndex(
            (a) => a.contrato === invoice.Contrato
          );

          // Converter data ISO para formato YYYY-MM-DD se necessário
          let vencimento = invoice.Vencimento;
          if (vencimento && vencimento.includes("T")) {
            vencimento = vencimento.split("T")[0];
          }

          // Criar objeto de acordo no formato esperado
          const invoiceAgreement = {
            contrato: invoice.Contrato,
            parcelas: [
              {
                valor: invoice.ValorDocumento,
                vencimento: vencimento,
              },
            ],
            // Informações adicionais do invoice para uso posterior
            invoiceData: {
              DigitableLine: invoice.DigitableLine,
              DownloadLink: invoice.DownloadLink,
              Telefone: invoice.Telefone,
              Email: invoice.Email,
              Nome: invoice.Nome,
            },
          };

          if (existingAgreementIndex >= 0) {
            // Se já existe, substituir (ou você pode optar por não substituir)
            this.$set(this.agreements, existingAgreementIndex, invoiceAgreement);
          } else {
            // Adicionar novo acordo
            this.agreements.push(invoiceAgreement);
          }

          // Atualizar localStorage com agreements atualizados
          try {
            localStorage.setItem("agreements", JSON.stringify(this.agreements));
          } catch (e) {
            console.warn("Erro ao salvar agreements no localStorage:", e);
          }
        }
      } catch (e) {
        console.error("Erro ao carregar invoices como acordos:", e);
      }
    },

    async logViewedAgreementsIfAny() {
      const ownerId = Number(process.env.VUE_APP_OWNER_ID);
      // Tribanco: 561 (Owners 8 prod / 22 HML) | Tricard: 563 (Owners 10 prod / 25 HML)
      if (![8, 22, 10, 25].includes(ownerId)) return;
      if (!Array.isArray(this.agreements) || this.agreements.length === 0) return;

      const contracts = this.agreements
        .map((a) => a?.contrato)
        .filter((c) => c !== null && c !== undefined && String(c).trim() !== "");

      try {
        await this.ActionViewAgreementsTribanco({
          IP: this.ipUser || "",
          OS: typeof navigator !== "undefined" ? navigator.platform : "",
          agreementsCount: this.agreements.length,
          NotesJson: {
            action: "view_agreements",
            agreementsCount: this.agreements.length,
            contracts,
            viewedAt: new Date().toISOString(),
          },
        });
      } catch (e) {
        console.warn("Log Visualizou Acordo ignorado:", e);
      }
    },
  },
  mounted() {
    this.expandAllBills();
  },
  async created() {
    this.largura = window.screen.width;
    const stored = localStorage.getItem("agreements");
    this.agreements = stored ? JSON.parse(stored) : [];

    console.log("agreeemensts antes de loadInvoices: " + JSON.stringify(this.agreements));

    // Buscar invoices e transformar em acordos fechados
    await this.loadInvoicesAsAgreements();

    console.log("agreeemensts depois de loadInvoices: " + JSON.stringify(this.agreements));

    await this.logViewedAgreementsIfAny();
    // if(this.agreements) {
    //   this.agreements.map((agreement) => {
    //     if(Array.isArray(agreement.parcelas) && agreement.parcelas.length) {
    //       this.installmentAgreements.push(agreement);
    //     }

    //     if(!Array.isArray(agreement.parcelas) && agreement.parcelas) {
    //       this.inCash.push(agreement);
    //     }

    //   });
    // }

    this.user.Menus.forEach((menuId) => {
      switch (parseInt(menuId)) {
        case 2:
          this.links.push({
            icon: "",
            text: "Contratos Negociáveis",
            route: "/dashboard/minhas-dividas",
          });
          break;
        case 1:
          this.links.push({
            icon: "",
            text: "Boletos Ativos",
            route: "meusBoletos",
          });
          break;
        case 3:
          this.links.push({
            icon: "",
            text: "Acordos",
            route: "/dashboard/meus-acordos",
          });
          break;
      }
    });
  },
  computed: {
    ...mapState("auth", ["user"]),
    isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },
  },
};
</script>
<style scoped>
td {
  border-top: none;
  align-content: center;
}
</style>